<mat-grid-list cols="4" rowHeight="270px" gutterSize="8px" class="voiceOfCustomer">
  <mat-grid-tile colspan="2" rowspan="1">
    <div class="layoutStyle" style="background-color: #5f249f;border-right-width: 0;">Account Highlights</div>
    <div class="layoutContent"style="overflow: auto; align-items: normal;">
      <ng-container *ngIf="!this.isLoading">
        <div *ngIf="this.accountDetails.length>0" style="padding:10px;">
          <table class="account-detail-table">
            <tr *ngFor="let item of this.accountDetails">
              <td style="min-width:150px;">{{item['name']}}</td>
              <td style="min-width:150px;">{{item['value']?item['value']:'null'}}</td>  
            </tr>
          </table>
        </div>
        <div style="height:100%;display:flex;align-items: center;" *ngIf="this.accountDetails.length===0">No Content</div>
      </ng-container>
      <div *ngIf="this.isLoading" class="spinner-container" style="display:flex;align-items: center;">
        <mat-spinner diameter=50 class="aip-topol-spinner"></mat-spinner>
      </div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1">
    <div class="voiceHead">
    <div class="headStyle">Account NPS</div>
    <div class="headContent" id="npsmain" style="overflow:auto"></div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1">
      <div class="voiceHead">
    <div class="headStyle">Gartner ETA Profile</div>
    <div class="headContent" id="gartnermain" style="overflow:auto"></div>
    </div>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="1">
    <div class="layoutStyle" style="background-color: #5f249f;border-right-width: 0;">Where is DXC Effective</div>
    <div class="layoutContent">No Content</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="1">
    <div class="layoutStyle" style="background-color: #5f249f;border-right-width: 0;">What can DXC do to Improve</div>
    <div class="layoutContent">No Content</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="1">
    <div class="layoutStyle" style="background-color: #5f249f;border-right-width: 0;">What can DXC do to be a better Partner</div>
    <div class="layoutContent">No Content</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="1">
    <div class="layoutStyle" style="background-color: #5f249f;border-right-width: 0;">Relationship & Future Needs</div>
    <div class="layoutContent">No Content</div>
  </mat-grid-tile>
</mat-grid-list>
<table class="p3-table">
    <thead>
        <tr>
            <th rowspan="2" style="background-color: #5f249f;">#</th>
            <th rowspan="2" style="background-color: #5f249f;">Key Client<br>Stakeholders</th>
            <th rowspan="2" style="background-color: #5f249f;">Title</th>
            <th rowspan="2" style="background-color: #5f249f;">Status</th>
            <th rowspan="2" style="background-color: #5f249f;">Influencer too?</th>
            <th colspan="4" style="background-color: #5f249f;">Personality / Social Style<br>Rate 1 – 4 (1 being major/highest)</th>
            <th rowspan="2" style="background-color: #999;">General Comments</th>
            <th rowspan="2" style="background-color: #999;">DXC Best Contact</th>    
        </tr>
        <tr>
            <th style="background-color: #249DC0;">Analytic</th>
            <th style="background-color: #F1563E;">Driver</th>
            <th style="background-color: #6CC24A;">Amiable</th>
            <th style="background-color: #F7CF2A;">Expressive</th>
        </tr>
    </thead>
    <tbody>
        <tr><td colspan="11">No Data</td></tr>
    </tbody>
</table>